import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
export function EventEditDeletePopup(_a) {
    var currentValue = _a.currentValue, allValue = _a.allValue, value = _a.value, onChange = _a.onChange;
    return (React.createElement(FormControl, { fullWidth: true },
        React.createElement(RadioGroup, { "aria-labelledby": "task-schedule-event-edit-delete-popup-radio-buttons-group", name: "task-schedule-event-edit-delete-popup-radio-buttons-group", value: value, onChange: onChange },
            React.createElement(FormControlLabel, { value: currentValue, control: React.createElement(Radio, null), label: 'This event' }),
            React.createElement(FormControlLabel, { value: allValue, control: React.createElement(Radio, null), label: 'All events in this schedule' }))));
}
